export function initScheduleFilter() {
  const $scheduleFilters = $('.schedule-filters');
  if (!$scheduleFilters || $scheduleFilters.length === 0) return;

  $('.schedule-filters-ftf').on('change', (e) => {
    const $t = $(e.currentTarget);
    if ($t.prop('checked')) {
      $('.schedule-filters-ftf-hidden').addClass('show');
    } else {
      $('.schedule-filters-ftf-hidden').removeClass('show');
    }
  });
}
